import { IconProps } from ".";
import Icon from "./assets/people_b_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24PeopleB(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
